import {
  Modal as CModal,
  ModalProps as CModalProps,
  ModalCloseButton,
  ModalContent,
  ModalContentProps,
  ModalHeader,
  ModalOverlay,
  ModalOverlayProps,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { useWindowSize } from 'react-use';
import ModalBody from '~/components/Modal/Body';

import ModalFooter from './Footer';

const propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  isFullScreenOnMobile: PropTypes.bool,
  modalContentProps: PropTypes.object,
  overlayProps: PropTypes.object,
};

const defaultProps = {
  children: null,
  isOpen: false,
  isFullScreenOnMobile: false,
};

interface ModalProps extends Omit<CModalProps, 'children'> {
  isFullScreenOnMobile?: boolean;
  modalContentProps?: ModalContentProps;
  children?: React.ReactNode;
  overlayProps?: ModalOverlayProps;
}

const Modal = ({
  isFullScreenOnMobile,
  children,
  modalContentProps,
  overlayProps,
  ...props
}: ModalProps) => {
  const { height } = useWindowSize(); // Hack for iOS https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
  return (
    <CModal isCentered {...props}>
      <ModalOverlay
        height={height}
        top={{ base: 'initial', md: 0 }}
        bottom={{ base: 0, md: 'initial' }}
        {...overlayProps}
      />
      <ModalContent
        containerProps={{ height: { base: '100%' } }}
        roundedTopLeft={{ base: isFullScreenOnMobile ? 0 : 'lg', md: 'lg' }}
        roundedTopRight={{
          base: isFullScreenOnMobile ? 0 : 'lg',
          md: 'lg',
        }}
        roundedBottomLeft={{ base: 0, md: 'lg' }}
        roundedBottomRight={{ base: 0, md: 'lg' }}
        alignSelf={{ base: 'flex-end', md: 'center' }}
        maxHeight={{ base: '100%', md: 'calc(100vh - 7rem)' }}
        {...modalContentProps}
      >
        {children}
      </ModalContent>
    </CModal>
  );
};

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;

Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.CloseButton = ModalCloseButton;
Modal.Header = ModalHeader;

export default Modal;
